var m = require('mithril');
var prop = require('mithril/stream');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var presentation = require('./scDiscoveryPresentation');
var devicePresentation = require('./deviceDiscoveryPresentation');

var discoveryModal = {};

function errorMessage(error) {
  if (!error) return 'BACnet/SC discovery failed.';
  if (typeof error === 'string') return error;
  return error.error || error.message || 'BACnet/SC discovery failed.';
}

function ridPath(recordOrRid, type) {
  var rid = recordOrRid && recordOrRid['@rid'] ? recordOrRid['@rid'] : recordOrRid;
  var text = String(rid || '');
  return text ? '/' + type + '/' + text.replace(/^#/, '') : '';
}

discoveryModal.open = function (onDone, initialConnectionRid) {
  var connections = prop([]);
  var connectionRid = prop(initialConnectionRid || '');
  var lowLimit = prop('');
  var highLimit = prop('');
  var timeoutSeconds = prop('3');
  var loading = prop(true);
  var running = prop(false);
  var error = prop('');
  var result = prop(null);

  function choices() {
    return presentation.connectionChoices(connections(), {
      includeManagedProfiles: Boolean(initialConnectionRid)
    });
  }

  function managedConnections() {
    return (connections() || []).filter(presentation.managed);
  }

  function setButtons() {
    modal.vm.buttons([
      {
        label: running() ? 'Discovering…' : (result() ? 'Discover Again' : 'Discover'),
        class: 'btn-good',
        disabled: function () { return loading() || running() || !connectionRid(); },
        func: submit
      }
    ]);
  }

  function requestBody() {
    var body = {
      timeoutMs: Math.round(Number(timeoutSeconds()) * 1000)
    };
    if (String(lowLimit()).trim() || String(highLimit()).trim()) {
      body.lowLimit = lowLimit();
      body.highLimit = highLimit();
    }
    return body;
  }

  function submit() {
    if (running() || !connectionRid()) return;
    running(true);
    error('');
    result(null);
    setButtons();
    m.redraw();
    return loaders.requestWithLoader({
      url: presentation.requestUrl(connectionRid()),
      method: 'POST',
      body: requestBody(),
      loader: 'submit'
    }).then(function (response) {
      result(response || { devices: [] });
      if (typeof onDone === 'function') onDone(response);
    }).catch(function (requestError) {
      error(errorMessage(requestError));
    }).finally(function () {
      running(false);
      setButtons();
      m.redraw();
    });
  }

  function resultTable(summary) {
    var devices = summary && summary.devices || [];
    if (!devices.length) return m('p.moon-gray', 'No devices responded during the discovery window.');
    return m('div.overflow-auto.mt3', { style: { maxHeight: '55vh' } }, [
      m('table.w-100.f5', { style: { minWidth: '1120px' } }, [
        m('thead', m('tr', [
          m('th.tl', 'Device'),
          m('th.tl', 'Source VMAC'),
          m('th.tl', 'Route'),
          m('th.tl', 'Vendor ID'),
          m('th.tl', 'Maximum APDU'),
          m('th.tl', 'Segmentation'),
          m('th.tl', 'Hub'),
          m('th.tl', 'Host'),
          m('th.tl', 'Result')
        ])),
        m('tbody', devices.map(function (device) {
          return m('tr', [
            m('td.tl.nowrap', device.deviceRid
              ? m(m.route.Link, { href: ridPath(device.deviceRid, 'bacnetdevice') }, device.deviceName)
              : device.deviceName),
            m('td.tl.nowrap.mono', devicePresentation.formatVmac(device.sourceVmac)),
            m('td.tl.nowrap', devicePresentation.routeLabel(device)),
            m('td.tl.nowrap', devicePresentation.numericLabel(device.vendorId)),
            m('td.tl.nowrap', devicePresentation.numericLabel(device.maxApdu)),
            m('td.tl.nowrap', devicePresentation.segmentationLabel(device.segmentation)),
            m('td.tl.nowrap', device.connectionName || summary.connectionName || '—'),
            m('td.tl.nowrap', device.hostRid
              ? m(m.route.Link, { href: ridPath(device.hostRid, 'bacnetserver') }, device.hostName)
              : device.hostName),
            m('td.tl.nowrap', presentation.deviceActionLabel(device.action))
          ]);
        }))
      ])
    ]);
  }

  function profileResults(summary) {
    var profiles = summary && summary.profiles || [];
    if (!profiles.length) return null;
    return m('div.mt3', [
      m('div.fw6.mb1', 'Managed profile results'),
      m('div.overflow-auto', m('table.w-100.f5', [
        m('thead', m('tr', [
          m('th.tl', 'Hub'),
          m('th.tl', 'Source'),
          m('th.tl', 'Outcome'),
          m('th.tl', 'Details')
        ])),
        m('tbody', profiles.map(function (profile) {
          return m('tr', [
            m('td.tl.nowrap', profile.connectionName || profile.managedKey),
            m('td.tl', profile.source || 'Cloud deployment configuration'),
            m('td.tl.nowrap', presentation.outcomeLabel(profile.outcome)),
            m('td.tl', profile.message || (
              (Number(profile.devicesCreated) || 0) + ' created; ' +
              (Number(profile.devicesMatched) || 0) + ' matched; ' +
              (Number(profile.devicesElsewhere) || 0) + ' elsewhere.'
            ))
          ]);
        }))
      ]))
    ]);
  }

  function managedBindingStatus() {
    var managed = managedConnections();
    if (!managed.length) return null;
    return m('div.mb3', [
      m('div.fw6', 'Cloud-managed bindings'),
      managed.map(function (connection) {
        var ready = presentation.managedReady(connection);
        return m('div.f5.mt1.' + (ready ? 'green' : 'yellow'), [
          m('span.fw6', connection.name + ': '),
          connection.managedStatus || (ready ? 'Ready.' : 'Unavailable.'),
          connection.managedSource ? m('span.moon-gray', ' Source: ' + connection.managedSource + '.') : null
        ]);
      })
    ]);
  }

  modal.vm.title('Discover BACnet/SC Devices');
  modal.vm.body = function () {
    var available = choices();
    var summary = result();
    return m('div', [
      m('p.mt0.moon-gray', 'Send a BACnet Who-Is through a BACnet/SC hub. Responding nodes are added to Hosts and their devices are placed beneath them.'),
      managedBindingStatus(),
      error() ? m('div.red.mb3', error()) : null,
      loading() ? m('div.tc.mv4', m('img.h1', { src: '/images/loading-bars.svg', alt: 'Loading' })) : null,
      !loading() && !available.length ? m('div.yellow.mb3', 'No enabled BACnet/SC hubs or cloud-managed bindings are available.') : null,
      !loading() && available.length ? m('form', { role: 'form', onsubmit: function (event) {
        event.preventDefault();
        submit();
      } }, [
        m('div.form-group', [
          m('label', 'Discovery source'),
          m('select.form-control', {
            value: connectionRid(),
            disabled: running(),
            onchange: function (event) { connectionRid(event.target.value); }
          }, available.map(function (choice) {
            return m('option', { value: choice.value }, choice.label);
          }))
        ]),
        m('div.flex-ns', [
          m('div.form-group.w-third-ns.pr2-ns', [
            m('label', 'Low Device Instance'),
            m('input.form-control', {
              type: 'number', min: 0, max: 4194303, placeholder: 'All',
              value: lowLimit(), disabled: running(),
              oninput: function (event) { lowLimit(event.target.value); }
            })
          ]),
          m('div.form-group.w-third-ns.ph2-ns', [
            m('label', 'High Device Instance'),
            m('input.form-control', {
              type: 'number', min: 0, max: 4194303, placeholder: 'All',
              value: highLimit(), disabled: running(),
              oninput: function (event) { highLimit(event.target.value); }
            })
          ]),
          m('div.form-group.w-third-ns.pl2-ns', [
            m('label', 'Response Window (seconds)'),
            m('input.form-control', {
              type: 'number', min: 1, max: 15, step: 1,
              value: timeoutSeconds(), disabled: running(),
              oninput: function (event) { timeoutSeconds(event.target.value); }
            })
          ])
        ])
      ]) : null,
      running() ? m('div.mv3.flex.items-center', [
        m('img.h1.mr2', { src: '/images/loading-bars.svg', alt: '' }),
        m('span', 'Listening for I-Am responses…')
      ]) : null,
      summary ? m('div.mt3', [
        m('div.f4', [
          (Number(summary.discovered) || 0) + ' discovered; ',
          (Number(summary.hostsCreated) || 0) + ' host' + (Number(summary.hostsCreated) === 1 ? '' : 's') + ' created; ',
          (Number(summary.devicesCreated) || 0) + ' device' + (Number(summary.devicesCreated) === 1 ? '' : 's') + ' created; ',
          (Number(summary.devicesMatched) || 0) + ' matched here; ',
          (summary.devicesElsewhere || 0) + ' configured elsewhere.'
        ]),
        summary.mode === 'managed' ? m('div.f5.moon-gray.mt1', [
          (summary.profilesSucceeded || 0) + ' managed profile' + (summary.profilesSucceeded === 1 ? '' : 's') + ' completed; ',
          (summary.profilesSkipped || 0) + ' skipped; ',
          (summary.profilesFailed || 0) + ' failed.'
        ]) : null,
        profileResults(summary),
        resultTable(summary)
      ]) : null
    ]);
  };
  setButtons();
  modal.vm.open({ extrawidth: true });

  return loaders.requestWithLoader({
    url: '/api/v1/bacnetscconnection',
    method: 'GET',
    loader: 'background'
  }).then(function (records) {
    connections(records || []);
    var available = choices();
    var selectedStillAvailable = available.some(function (choice) {
      return choice.value === connectionRid();
    });
    if (!selectedStillAvailable && available.length) connectionRid(available[0].value);
  }).catch(function (requestError) {
    error(errorMessage(requestError));
  }).finally(function () {
    loading(false);
    setButtons();
    m.redraw();
  });
};

discoveryModal.__test = presentation;

module.exports = discoveryModal;
